<template>
    <div v-show="isShow" class="screencapStylse">
        <div style="z-index:9999; position: relative;"id="screencap">
            <div>
                <div>
                    <p class="title"  @mousedown="openDrag" @mouseup="dragStop">
                        <span style="position: absolute;left: 5px;font-size: 12px;">屏幕录制</span>
                        <Icon type="md-videocam" title="录制"  id='record' @click='record()'/>
                        <Icon type="ios-square" title ="停止"  style='display: none'  id='stop' @click='stop()'/>
                        <Icon type="md-download" title ="下载" disabled='true'  id='download' @click='download()'/>
                        <Icon type="ios-expand" title="还原" v-show="!isShowReduction" style='display: none' @click="reduction()" />
                        <Icon type="md-open" title="最小化"  v-show="isShowReduction" @click="minimize()"/>
                    </P>
                    <video autoplay='true' id='video' controls='true' controlsList='nodownload'></video>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"screencap",
    data() {
        return {
            isShow:false,
            titleLeft:0,//存储移动后的值
            titleTop:0,//存储移动后的值
            isShowReduction:true//记录放大和还原
        }
    },
    mounted() {
        this.$store.registerModule(["system", "screencap"], {
            state: {
                $: this,
            },
        });
        // this.isShow = isShow ? true : false;
        this.video = document.getElementById('video');
        this.downloadBtn = document.getElementById('download');
        this.recordBtn = document.getElementById('record');
        this.stopBtn = document.getElementById('stop');
        this.screencap = document.getElementById("screencap");
        this.recorder;
    },
    methods: {
        show(){
            this.isShow = !this.isShow;
        },
        //鼠标按下
        openDrag(){
            if(!this.isShowReduction) return
            let oDiv=document.getElementById("screencap");
            oDiv.onmousedown = function (e) {
                if(oDiv.style.cursor!=="move"){
                    oDiv.style.cursor="move";
                }
                // 鼠标按下，计算当前元素距离可视区的距离
                let disX = e.clientX - oDiv.offsetLeft;
                let disY = e.clientY - oDiv.offsetTop;
                document.onmousemove = function (e) {
                    // 通过事件委托，计算移动的距离
                    let l = e.clientX - disX;
                    let t = e.clientY - disY;
                    // 移动当前元素
                    oDiv.style.left = l + 'px';
                    oDiv.style.top = t + 'px';
                }
                document.onmouseup = function (e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                    oDiv.style.cursor="default";
                }
                return false
            }
        },
        //鼠标抬起
        dragStop () {
            let oDiv=document.getElementById("screencap");
            oDiv.onmouseup = function (e) {
                oDiv.onmousemove = null;
                oDiv.onmousedown = null;
                oDiv.onmouseup = null;
                return false
            }
        },
        //最小化
        minimize(){
            this.isShowReduction =  false;
            this.titleLeft = this.screencap.style.left;
            this.titleTop = this.screencap.style.top;
            this.video.style = 'display: none';
            this.screencap.style.top = 0;
            this.screencap.style.left = 0;
        },
        //还原
        reduction(){
            this.isShowReduction = true;
            this.video.style = 'display: inline';
            this.screencap.style.top = this.titleTop;
            this.screencap.style.left = this.titleLeft;
        },
        //跳转录屏界面
        /**
        a. 打开 chrome://flags/#unsafely-treat-insecure-origin-as-secure
        b. 搜索Insecure origins treated as secure
        c. 将Disabled改为Enabled，在输入框填写相应的URL，多个URL通过‘，’分开
        d. 修改之后出现relaunch按钮，点击按钮重启浏览器
        */
        async record() {
            this.minimize();
            // 开始录屏
            let captureStream;
            try{
                captureStream = await navigator.mediaDevices.getDisplayMedia({
                    video: true,
                    // audio: true,   not support
                    cursor: 'always'
                })
            }catch(e){
                // 取消录屏或者报错
                // alert("Could not get stream")
                return
            }
            this.downloadBtn.disabled = true;
            this.recordBtn.style = 'display: none';
            this.stopBtn.style = 'display: inline';
            // 删除之前的 Blob
            window.URL.revokeObjectURL(this.video.src);
            this.video.autoplay = true;
            // 实时的播放录屏
            this.video.srcObject = captureStream;
            // new 一个媒体记录
            this.recorder = new MediaRecorder(captureStream);
            this.recorder.start();
            captureStream.getVideoTracks()[0].onended = () => {
                // 录屏结束完成
                this.recorder.stop();
            }
            this.recorder.addEventListener("dataavailable", event => {
                // 录屏结束，并且数据可用
                let videoUrl = URL.createObjectURL(event.data, {type: 'video/ogg'});
        
                this.video.srcObject = null;
                this.video.src = videoUrl;
                this.video.autoplay = false;
        
                this.downloadBtn.disabled = false;
                this.recordBtn.style = 'display: inline';
                this.stopBtn.style = 'display: none';
            })
        },
        //下载
        download(){
            const url = this.video.src;
            const name = new Date().toISOString().slice(0, 19).replace('T',' ').replace(" ","_").replace(/:/g,"-");
            const a = document.createElement('a');
            a.style = 'display: none';
            a.download = `${name}.ogg`;
            a.href = url;
            document.body.appendChild(a);
            a.click();
        },
        //停止
        stop(){
            let tracks = this.video.srcObject.getTracks();
            tracks.forEach(track => track.stop());
            this.recorder.stop();
        }
    },
}
</script>
<style>
    .screencapStylse{
        width: 200px;
        height: 200px;
        position: absolute;
        top: 1px;
        right: 1px;
    }
    .title{
        background:#ccc;
        text-align: right;
        padding-right: 5px;
        font-size: 15px;
    }
    #controls{
        text-align: center;
    }
    #stop{
        color: #fc5c65;
    }
    #video{
        outline: none;
        width: 200px;
        height: 200px;
        background-color: black;
    }
    h1{
        color: #2bcbba;
        letter-spacing:-2.5px;
        line-height: 30px;
    }
    .title i{
        cursor:pointer;
    }
    .title i:hover{
        color: #0036ce;
        cursor: hand;
    }
</style>


// WEBPACK FOOTER //
// src/components/system/screencap.vue